<script setup lang="ts">
import { ref, watch } from 'vue';
import AppSidebar from './sidebar/AppSidebar.vue';

const { showMenu = false } = defineProps<{
  showMenu?: boolean;
}>();

const showMobileMenu = ref(false);
const emit = defineEmits(['closeMenu']);

watch(
  () => showMenu,
  (v) => {
    showMobileMenu.value = v;
  },
);
</script>

<template>
  <VaModal
    v-model="showMobileMenu"
    size="small"
    no-outside-dismiss
    hide-default-actions
    stateful
    no-padding
    class="p-6"
  >
    <AppSidebar :minimized="false" :mobile="true" :tablet="false" @update:menuItemClicked="showMobileMenu = false" />
    <span class="mt-6 flex text-lg justify-center" @click="emit('closeMenu')"> Close </span>
  </VaModal>
</template>
